import { FC } from "react";

import { Button, Drawer as MaterialDrawer } from "@material-ui/core";

import clsx from "clsx";

import { useStyles } from "./style";
import { useHistory } from "react-router-dom";

interface Props {
    isOpen: boolean;
}

export const Drawer: FC<Props> = ({ isOpen }) => {
    const classes = useStyles();
    const history = useHistory();

    const handleCreateUser = () => {
        history.push("/user/create");
    };

    const handleModifyUser = () => {
        history.push("/user/create");
    };

    return (
        <MaterialDrawer
            variant="permanent"
            className={clsx({
                [classes.drawerOpen]: isOpen,
                [classes.drawerClose]: !isOpen,
            })}
            classes={{
                paper: clsx({
                    [classes.drawerOpen]: isOpen,
                    [classes.drawerClose]: !isOpen,
                }),
            }}
        >
            <div className={classes.spacing} />
            <div className={classes.apps}>
                <Button
                    type="button"
                    fullWidth
                    variant="text"
                    className={classes.text}
                    onClick={handleCreateUser}
                >
                    Crear Usuario
                </Button>

                {/* <Button
                    type="button"
                    fullWidth
                    variant="text"
                    className={classes.text}
                    onClick={handleModifyUser}
                >
                    Modificar Usuario
                </Button> */}
            </div>
        </MaterialDrawer>
    );
};
